<template>
  <div>
    <px-view-header title="Cadastro de Unidade de Medida"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"
                    default-title-column-size="8"
                    default-breadcrumbs-column-size="4">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingUnidadeMedida">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição da Unidade de Medida"
            :error="$v.unidadeMedida.descricao.$error"
            @blur="$v.unidadeMedida.descricao.$touch()"
            v-model="unidadeMedida.descricao"
          />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno"
            v-model="unidadeMedida.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="unidadeMedida.ativo"/>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import UnidadesMedidaService from './unidades-medida-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingUnidadeMedida: false,
      unidadeMedida: {
        descricao: null,
        codigoInterno: null,
        ativo: true,
      },
      unidadeMedidaId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Unidades de Medida' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.unidades' });
    },
    getUnidadeMedida() {
      this.loadingUnidadeMedida = true;
      UnidadesMedidaService.get(this.unidadeMedidaId)
        .then((response) => {
          this.unidadeMedida = response.data;
        })
        .finally(() => {
          this.loadingUnidadeMedida = false;
        });
    },
    salvar() {
      this.loading = true;
      UnidadesMedidaService.save(this.unidadeMedida)
        .then(() => {
          this.$toast('Unidade de Medida criada com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.unidadeMedidaId) {
      this.getUnidadeMedida();
    }
  },
  validations: {
    unidadeMedida: {
      descricao: {
        required,
      },
    },
  },
};
</script>
